import { gql } from '@apollo/client'

export default {
  getGroupParents: () => gql`
    query GetGroupParents($rmsId: ID!, $parentGroupType: GroupType) {
      groupParents(rmsId: $rmsId, parentGroupType: $parentGroupType) {
        properties {
          name
          type
          values
        }
        id
        title
        groupName
      }
    }
  `,
  getCollection: () => gql`
    query GetCollection($collectionId: ID!) {
      collection(collectionId: $collectionId) {
        title
      }
    }
  `,
  getRecordTypes: gql`
    query getRecordTypes {
      recordTypes {
        id
        name
      }
    }
  `,
}
